"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isNil = _interopRequireDefault(require("./isNil"));

var _isString = _interopRequireDefault(require("./isString"));

var isEmptyString = function isEmptyString(obj) {
  return (0, _isNil["default"])(obj) || (0, _isString["default"])(obj) && obj.length === 0;
};

var _default = isEmptyString;
exports["default"] = _default;